import EventActionProto from '../event-action-proto';
import TaskType from "../../model2/task-type/task-type";

module.exports = class EventTaskTypeNew extends EventActionProto {

    constructor(uid, data) {
        super(uid, data);
    }

    validate() {
        return true;
    }

    process() {


        this.data.map(tt=>{

            if (!gd.session.taskTypes.get(tt.id)) {
                gd.session.taskTypes.add(new TaskType(tt))
                // add
            } else {
                // update
                //gd.session.statuses.get(s['id']).set({
                //    name: s['name'],
                //    color: s['color'],
                //    isDeleted: s['isDeleted']
                //});
                console.error("Error #94847655 not meant to happen...");
            }


        });


        super.process();
    }
};

